{ #if odds }
  <div class={ "odds" + (classes ? ' ' + classes : '') }>
    <div class="odds-header">
      <slot />
    </div>
    <div class="column-group odds-block">
      { #each odds.odds as odd, index }
      <div class="all-33 odd">
        <span class="odd-result">{ [ '1', 'X', '2' ][index] }</span>
          <div class="odd-value">
            { #if odd }
              <b>{ odd.odd.toFixed(2) }</b>
              { #if providers.find(item => item.id === odd.provider) }
              <span>{ providers.find(item => item.id === odd.provider).name }</span>
              { /if }
            { :else }
              <b>-</b>
              <span>-</span>
            { /if }
          </div>
        </div>
      { /each }
    </div>
  </div>
{ /if }

<script>
  export default {
    data () {
      return {
        classes: ''
      }
    }
  }
</script>
<style type="text/scss">
  @import './style/utilities';
  
  .odds {
    margin-bottom: 20px;
  }
  
  .odds-block {
    padding: 8px;
    padding-bottom: 0;
    background-color: color(scale, 20%);
    text-align: center;
    color: white;
    .odds-block--tall & {
      padding: 10px;
      /* @include mobile {
        padding: 16px 8px;
      } */
    }
  }

  .odd {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .odd-value {
    background-color: color(scale, 25%);
    border: none;
    outline: none;
    width: 120px;
    padding: 6px;
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    color: white;
    overflow: hidden;
    @include tablet {
      width: 86px;
    }
    @include mobile-small {
      width: 70px;
    }
    &:hover {
      background-color: color(scale, 30%);;
    }
    .odds-block--tall & {
      padding: 10px 8px;
    }
    span {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 12px;
      font-weight: 300;
      color: color(scale, 80%);
      letter-spacing: 1px;
    }
  }

  .odds-market {
    text-align: center;
    margin: 0 auto;
    &:first-child {
      margin-top: -48px;
    }
  }

  .odd-result {
    margin-bottom: 0;
    margin-right: 32px;
    font-weight: 300;
    font-size: 15px;
    color: color(scale, 80%);
    @include tablet{
      margin-right: 24px;
    }
    @include tablet-large {
      margin-right: 16px;
    }
    @include mobile{
      margin-right: 10px;
    }
    
  }

  .odds-header {
    background-color: color(scale, 5%);
    padding: 8px 0;
    font-size: 14px;
    font-weight: 300;
    color: white;
    text-transform: uppercase;
    text-align: center;
    line-height: 1;
    .odds-block--tall & {
      padding: 11px 0;
    }
  }
</style>
